import { Link } from 'react-router-dom';
import { productCategories } from '@/mocks/products';

function ProductShowcase() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            產品系列
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            針對不同需求設計多個系列，找到最適合您的活力方案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8" data-product-shop>
          {productCategories.map((category) => (
            <Link
              key={category.id}
              to={`/category?tab=${category.id}`}
              className="group bg-background-100/70 rounded-lg overflow-hidden cursor-pointer flex flex-col md:flex-row"
            >
              <div className="w-full md:w-48 h-40 md:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col justify-center flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {category.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{category.description}</p>
                <div className="flex flex-wrap gap-2">
                  {category.products.slice(0, 3).map((p) => (
                    <span
                      key={p.id}
                      className="text-xs bg-background-200/70 text-foreground-700 px-2.5 py-1 rounded-full whitespace-nowrap"
                    >
                      {p.name}
                    </span>
                  ))}
                  {category.products.length > 3 && (
                    <span className="text-xs text-foreground-500 py-1">+{category.products.length - 3}款</span>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-1.5 bg-primary-500 text-background-50 px-6 py-3 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            瀏覽全部產品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ProductShowcase;